import React, { useState } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import {
    DashboardOutlined,
    HourglassTopOutlined,
    ManageAccountsOutlined,
    PersonSearchOutlined,
    FiberNewOutlined,
    MonitorHeartOutlined,
    HomeOutlined,
    CampaignOutlined,
    BusinessOutlined,
} from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

import EcrOpsPlatformSelector from "./components/EcrOpsPlatformSelector";

import "./EcrOpsLayout.css";

const NAV_ITEMS = [
    {
        label: "Home Dashboard",
        to: "/dashboard",
        icon: <HomeOutlined />,
    },
    {
        label: "OPS Homepage",
        to: "/ecr-ops",
        icon: <DashboardOutlined />,
        end: true,
    },
    {
        label: "Search",
        to: "/ecr-ops/search",
        icon: <PersonSearchOutlined />,
    },
    {
        label: "Org Management",
        to: "/ecr-ops/org-management",
        icon: <ManageAccountsOutlined />,
    },
    {
        label: "New Organisations",
        to: "/ecr-ops/new-orgs",
        icon: <FiberNewOutlined />,
    },
    {
        label: "System Health",
        to: "/ecr-ops/health",
        icon: <MonitorHeartOutlined />,
    },
    {
        label: "Enterprise Usage",
        to: "/ecr-ops/copilot-enterprise",
        icon: <BusinessOutlined />,
    },
    {
        label: "Stuck Users",
        to: "/ecr-ops/stuck-users",
        icon: <HourglassTopOutlined />,
    },
    {
        label: "Portal Config",
        to: "/ecr-ops/portal-config",
        icon: <CampaignOutlined />,
    },
];

const EcrOpsLayout = () => {
    const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div className="ecr-ops-shell">
            {/* ── Sidebar ── */}
            <aside className={`ecr-ops-sidebar ${collapsed ? "collapsed" : ""}`}>
                <div className="ecr-ops-sidebar__header">
                    {!collapsed && (
                        <button
                            className="ecr-ops-sidebar__brand"
                            onClick={() => navigate("/ecr-ops")}
                            type="button"
                            aria-label="Go to ECR Ops home"
                        >
                            <span className="ecr-ops-sidebar__brand-badge">ECR</span>
                            <span className="ecr-ops-sidebar__brand-label">Ops Portal</span>
                        </button>
                    )}
                    <button
                        className="ecr-ops-sidebar__toggle"
                        onClick={() => setCollapsed((c) => !c)}
                        aria-label="Toggle sidebar"
                    >
                        {collapsed ? <MenuIcon fontSize="small" /> : <CloseIcon fontSize="small" />}
                    </button>
                </div>

                <nav className="ecr-ops-sidebar__nav">
                    {NAV_ITEMS.map((item) => {
                        // Special handling for search routes - make active when on any search subroute
                        const isSearchLink = item.to.includes('/search');
                        const isSearchActive = isSearchLink && location.pathname.includes('/search');

                        return (
                            <NavLink
                                key={item.to}
                                to={item.to}
                                end={item.end}
                                className={({ isActive }) =>
                                    `ecr-ops-sidebar__link${(isActive || isSearchActive) ? " active" : ""}`
                                }
                                title={collapsed ? item.label : undefined}
                            >
                                <span className="ecr-ops-sidebar__link-icon">{item.icon}</span>
                                {!collapsed && (
                                    <span className="ecr-ops-sidebar__link-label">{item.label}</span>
                                )}
                            </NavLink>
                        );
                    })}
                </nav>

                {!collapsed && (
                    <div className="ecr-ops-sidebar__footer">
                        <span>ECR Operations</span>
                    </div>
                )}
            </aside>

            {/* ── Main content ── */}
            <main className="ecr-ops-main">
                <div className="ecr-ops-platform-bar">
                    <EcrOpsPlatformSelector />
                </div>
                <Outlet />
            </main>
        </div>
    );
};

export default EcrOpsLayout;
